module.exports = __webpack_public_path__ + "img/blis2.4ee9f78c.png";